import styled, { css } from 'styled-components';

import { colors, medias } from 'assets/styled/tokens';

import closeIcon from 'assets/icons/close-gray.svg';
import plusIcon from 'assets/icons/plus.svg';

const ChipStyle = css`
  position: relative;
  display: inline-flex;
  flex-flow: row wrap;
  align-items: center;
  justify-content: flex-start;
  padding: 5px 10px 6px 10px;
  border: 1px solid ${colors.lightGray};
  border-radius: 100px;
  color: ${colors.gray};
  cursor: pointer;
  gap: 5px;

  @media (max-width: ${medias.tablet}) {
    display: flex !important;
    flex-flow: row nowrap;
  }
`;

export const StyledFilter = styled.div`
  line-height: 13px;
`;

export const StyledFilterLabel = styled.label`
  display: flex;
  font-size: 0.6875rem;
  line-height: 13px;

  ${ChipStyle};
  background-color: ${colors.westar};

  @media (max-width: ${medias.tablet}) {
    white-space: nowrap;
    display: flex;
    margin-right: 0;
    font-weight: 400;
    flex-flow: row nowrap;
  }

  span {
    position: absolute;
    width: 0;
    height: 0;
    opacity: 0;
  }
  button {
    width: 14px;
    height: 14px;
    padding: 0;
    background: transparent url(${plusIcon}) no-repeat center/10px 10px;
    color: transparent;

    &:focus {
      box-shadow: none;
    }
  }
`;

export const StyledFilterChip = styled.div`
  ${ChipStyle};

  span {
    font-size: 0.6875rem;
    line-height: 13px;
    display: block;
    max-width: 200px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  button {
    width: 14px;
    height: 14px;
    padding: 0;
    color: transparent;
    margin-left: 3px;
    background: transparent url(${closeIcon}) no-repeat center/8px 8px;
    display: ${props => props.disableOpen && 'none'};
    overflow: hidden;

    @media screen and (max-width: ${medias.tablet}) {
      font-size: 0;
      span {
        position: absolute;
        height: 0;
        width: 0;
      }
    }
  }

  cursor: ${props => props.disableOpen && 'default'};

  @media screen and (max-width: ${medias.tablet}) {
    display: inline-block;
  }
`;
